import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Activation } from '../models/activation';
import { ActivationService } from '../services/activation.service';
import { ValidFor } from '../models/validFor';

@Component({
    selector: 'app-activation',
    templateUrl: './activation.component.html'
})

export class ActivationComponet {

    validList: ValidFor[] = [];
    selectedValidFor: number;
    public resCode;
    public respReq;
    public error = false;
    public resError;
    isDisabled: boolean = false;

    constructor(private translate: TranslateService, public service: ActivationService, private toastr: ToastrService, private authService: AuthService, private spinner: NgxSpinnerService) {
        this.service.GetValidFor().subscribe(data => {
            this.validList = data
        });
    }
    activation = new Activation();

    ngOnInit() {
        if (this.authService.getRolFromToken() == "2") //Country responsible
        {
            this.selectedValidFor = 0;
            this.isDisabled = true;
        }
        else
            this.isDisabled = false;
    }

    onSubmit(form: NgForm) {
        this.spinner.show();
        form.value.logUser = this.authService.getLoginFromToken();

        this.service.requestActivation(form.value).subscribe(

            res => {
                this.respReq = true;
                this.error = false;
                this.resCode = res;
                this.toastr.success('Ok.', this.translate.instant("ACTIVATION.CONTINGENCY_ACTIVATION"))
                this.spinner.hide();
            },
            err => {
                this.respReq = true;
                this.error = true;
                this.resError = this.translate.instant(err.error.translateKey);
                this.spinner.hide();

            }
        )
    }

    resetForm(form: NgForm) {
        form.resetForm();
    }

}
